export const PROFILE = {
  TYPE: {
    MERCHANT: 'Merchant',
    MERCHANT_STAFF: 'MerchantStaff',
  }
};